import { Route } from 'react-router-dom';
import { safeLazy } from '@/components/SafeLazy/SafeLazy';

const Settings = safeLazy(() => import('./Settings'));

// Nested Route Util
const SwapSection = safeLazy(() => import('./(Resources)/SwapSection'));

// Nested Routes
const User = safeLazy(() => import('./User/User'));
const BusinessLoader = safeLazy(() => import('./Business/BusinessLoader'));
const Options = safeLazy(() => import('./Options/Options'));

const Marketplace = safeLazy(() => import('./Marketplace/Marketplace'));

const Security = safeLazy(() => import('./Security/Security'));
const Connections = safeLazy(() => import('./Security/Connections'));
const Password = safeLazy(() => import('./Security/Password'));

const Admin = safeLazy(() => import('./Admin/Admin'));
const ResourceSummary = safeLazy(() => import('./Stats/Stats'));

const Suppliers = safeLazy(() => import('./Suppliers/Suppliers'));
const SuppliersProfile = safeLazy(() => import('./Suppliers/SupplierForm'));

const Employees = safeLazy(() => import('./Employees/Employees'));
const EmployeeProfile = safeLazy(() => import('./Employees/EmployeeForm'));
const Permissions = safeLazy(() => import('./(Resources)/Permissions/Permissions'));

const AllowedChains = safeLazy(() => import('./(Resources)/Permissions/Chains/ChainsPermissions'));

const Activities = safeLazy(() => import('./Employees/Activities'));

const Apps = safeLazy(() => import('./Apps/Apps'));
const AppForm = safeLazy(() => import('./Apps/AppForm'));

interface RoutesProps {
  industry: boolean;
  admin: boolean;
}

const routes = ({ industry, admin }: RoutesProps) => (
  <Route path="/settings" key="/settings" element={<Settings />}>
    <Route path="user" element={<User />} />
    <Route path="options" element={<Options />} />
    <Route path="marketplace" element={<Marketplace />} />
    <Route path="security" element={<Security />}>
      <Route path="connections" element={<Connections />} />
      <Route path="connections/:page" element={<Connections />} />
      <Route path="password" element={<Password />} />
    </Route>
    {admin && <Route path="admin" element={<Admin />} />}
    {industry && (
      <>
        <Route path="business" element={<BusinessLoader />} />
        <Route path="stats" element={<ResourceSummary />} />
        <Route path="employees" element={<SwapSection />}>
          <Route index element={<Employees />} />
          <Route path="new" element={<EmployeeProfile />} />
          <Route path=":id/edit" element={<EmployeeProfile />} />
          <Route path=":id/permissions" element={<Permissions />} />
          <Route path=":id/permissions/chains" element={<AllowedChains />} />
          <Route path=":id/activities" element={<Activities />} />
        </Route>
        <Route path="suppliers" element={<SwapSection />}>
          <Route index element={<Suppliers />} />
          <Route path="new" element={<SuppliersProfile />} />
          <Route path=":id/edit" element={<SuppliersProfile />} />
        </Route>
      </>
    )}
    <Route path="apps" element={<SwapSection />}>
      <Route index element={<Apps />} />
      {industry && (
        <>
          <Route path="new" element={<AppForm />} />
          <Route path=":id/edit" element={<AppForm />} />
          <Route path=":id/permissions" element={<Permissions />} />
          <Route path=":id/permissions/chains" element={<AllowedChains />} />
        </>
      )}
    </Route>
  </Route>
);

export default routes;
